import React, { useEffect, useState } from "react";
import { Button } from '../../index';
import { messageError, messageSuccess } from '../../../components/toastr';

export const StatusRequestTimer = ({ plate, serviceCmd, getStatusPlate, pauseTimer }) => {
    const initialTimer = 120;
    const [timer, setTimer] = useState(initialTimer);

    useEffect(() => {
        let interval = null;

        if (!pauseTimer && timer >= 0) {
            interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [pauseTimer, timer]);

    useEffect(() => {
        if (timer < 0) {
            getStatusPlate(plate);
        }
    }, [timer, plate]);

    const sendStatusRequest = (data) => {
        setTimer(initialTimer);

        serviceCmd
            .sendStatusRequest(data)
            .then(response => {
                if (response.data.status !== 200) {
                    messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
                } else {
                    messageSuccess("Comando transmitido. Aguarde o retorno do dispositivo.");
                }
            })
            .catch(erros => {
                if (erros.response.status === 400) {
                    messageError(erros.response.data.message);
                } else {
                    messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
                }
            })
    };

    return (
        <Button
            style={{ marginRight: "12px", width: '150px' }}
            type='primary'
            children={'Status Request (' + timer + ')'}
            block
            onClick={() => {
                sendStatusRequest({ "plate": plate })
                getStatusPlate(plate);
            }}
        />
    );
}

